<script lang="ts">
  import { getThumbnailURL } from "../../../lib";
  import TimeIcon from "../TimeIcon.svelte";
  import T from "../texts";

  export let s;
  export let isOnline;
  export let nextOnlineTime;
  export let settings;
  export let language;
  export let chatHidden: boolean = false;
  export let gradientColor;
</script>

<div class={gradientColor ? s.chatHeaderGradient : s.chatHeader}>
  <div class={s.leftChatHeader}>
    <div class={s.agentGroup}>
      {#if settings.user_ids && settings.user_ids.length > 2}
        {#each settings.user_ids
          .sort(() => 0.5 - Math.random())
          .slice(0, 3) as user_id}
          <img
            class={s.agentThumbnail}
            src={getThumbnailURL(user_id)}
            alt="agent"
          />
        {/each}
      {:else if settings.user_ids.length === 2}
        {#each settings.user_ids as user_id}
          <img
            class={s.agentThumbnailTwo}
            src={getThumbnailURL(user_id)}
            alt="agent"
          />
        {/each}
      {:else}
        <img
          class={s.agentThumbnailOne}
          src={getThumbnailURL(settings.user_ids[0])}
          alt="agent"
        />
      {/if}

      {#if isOnline}
        <div
          class={s.onlineDot}
          style={`left: ${settings.user_ids.length > 2 ? "-3px" : settings.user_ids.length == 2 ? "4px" : "-6px"}`}
        ></div>
      {:else}
        <div
          class={s.offlineDot}
          style={`left: ${settings.user_ids.length > 2 ? "-3px" : settings.user_ids.length == 2 ? "4px" : "-6px"}`}
        ></div>
      {/if}
    </div>

    <div class={s.headerMessage}>
      <div class={s.headerTitle}>{settings.name}</div>
      {#if !isOnline && nextOnlineTime}
        <div class={s.returnTime}>
          <TimeIcon />&nbsp;{T(language, "Back online {0}", [
            nextOnlineTime.toLowerCase(),
          ])}
        </div>
      {:else}
        <div class={s.returnTime}>{T(language, "We're here to help!", [])}</div>
      {/if}
    </div>
  </div>

  <div
    class={s.minimizeButton}
    on:click={() => {
      chatHidden = !chatHidden;
    }}
    on:keydown={(e) => e.key === 'Enter' && (chatHidden = !chatHidden)}
    tabindex="0"
    role="button"
  >
    <svg
      width="20"
      height="3"
      viewBox="0 0 20 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5714 3H1.42857C0.642857 3 0 2.325 0 1.5C0 0.675 0.642857 0 1.42857 0H18.5714C19.3571 0 20 0.675 20 1.5C20 2.325 19.3571 3 18.5714 3Z"
        fill={s.headerColor}
        fill-opacity="1"
      />
    </svg>
  </div>
</div>
